import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import MantProducto from "./components/MantProducto";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import List from "../../global/content/List";
const MySwal = withReactContent(Swal);

const PageProducto = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [page, setPage] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [pages, setPages] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [limit, setLimit] = useState(CONFIGURACIONES.INIT.LIMIT_PAGE);
    const [param, setParam] = useState(CONFIGURACIONES.INIT.STRING);
    const [dataList, setDataList] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [endPointShow, setEndPointShow] = useState(CONFIGURACIONES.INIT.STRING);
    const [endPointUpdate, setEndPointUpdate] = useState(CONFIGURACIONES.INIT.STRING);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [tiposCredito, setTiposCredito] = useState(CONFIGURACIONES.INIT.ARRAY);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const createComponent = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        console.log(`${CONFIGURACIONES.SITES.PRODUCTOS}/new`);
        
        navigate(`${CONFIGURACIONES.SITES.PRODUCTOS}/new`);
    };

    const editComponent = (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        setEndPointShow(param.links.find(link => link.rel === CONFIGURACIONES.REFS.SELF)?.href || null);
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        navigate(`/view/productos/${param.id}`);
    };

    const deleteComponent = async (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)) { return; }
        let endPointDelete = param.links.find(link => link.rel === CONFIGURACIONES.REFS.DELETE)?.href || null;
        // console.log('endpoint', endPointDelete); 
        await Functions().deleteElement(endPointDelete, CONFIGURACIONES.MESSAGES.SUCCESS_DELETE_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.PRODUCTOS} <strong>${param.nombre}</strong>`,  getUser(), loadData, {})
    };

    const closeSection = () => {
        setParam(CONFIGURACIONES.INIT.STRING);
        setPage(CONFIGURACIONES.INIT.CURRENT_PAGE);
        setLimit(CONFIGURACIONES.INIT.LIMIT_PAGE);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        navigate(`${CONFIGURACIONES.SITES.PRODUCTOS}`);
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const createDataComponent = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().save(CONFIGURACIONES.ENDPOINTS.PRODUCTOS, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), closeSection, form);
    };

    const updateComponent = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        await Functions().update(endPointUpdate, CONFIGURACIONES.MESSAGES.SUCCESS_UPDATE_OPERATION, getUser(), closeSection, form);
    }

    
    const initData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.PRODUCTOS}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setTiposCredito(rpta.data.tiposCredito);
            }
        });
    }

    const loadData = () => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.PRODUCTOS}?param=${param}&page=${page}&limit=${limit}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataList(rpta.data);
                setPages(rpta.pagination.pages);
            }
        });
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        let search = localStorage.getItem('search');
        console.log('search', search);
        
        if (!search) {
            showSpinnerLoader();
        }
        localStorage.removeItem('search');
        // loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        } else {
            loadData();
        }
    }, [location.pathname, page, param, limit])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (<div className="col-md-12 col-xs-12">
                        <div className="card">
                            <div className="card-body">
                                <List icon={iconActive} title={'Productos'} headers={CONFIGURACIONES.TABLES.HEADERS.PRODUCTOS} data={dataList} fnCreate={createComponent} fnEdit={editComponent} fnDelete={deleteComponent} setPage={setPage} pages={pages} page={page} 
                                    setParam={setParam} entityPagination={'producto'} setLimit={setLimit} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)}
                                    showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} dataTooltipId={'create_producto'} content={'Crear Producto'} />
                            </div>
                        </div>
                    </div>)}

                    {!isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantProducto mant={'Producto'} idEdit={idRef} closeSection={closeSection} MySwal={MySwal} idRef={idRef} setIdRef={setIdRef} createData={createDataComponent} updateData={updateComponent} endPointShow={endPointShow} 
                                        setEndPointUpdate={setEndPointUpdate} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} init={initData} tiposCredito={tiposCredito}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PageProducto;